import React from 'react';
import ReactConfetti from 'react-confetti';
import Button from 'src/components/_common/Button/Button';
import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalFooterButtonWrapper,
  ModalHeader,
  ModalIcon,
  ModalTitle,
  ModalTitleWrapper,
} from 'src/components/_common/Modal/index.styled';
import { useAppDispatch } from 'src/store/client/config';
import { modalActions } from 'src/store/client/slices/modalSlice';
import styled from 'styled-components';

interface DailyAttendanceModalProps {
  point: number;
}

const DailyAttendanceModal = ({ point }: DailyAttendanceModalProps) => {
  const dispatch = useAppDispatch();

  const handleOnClose = () => {
    dispatch(modalActions.closeModal());
  };

  return (
    <Container>
      {/* 폭죽 표시 */}
      <ReactConfetti
        width={window?.innerWidth || 0}
        height={window?.innerHeight || 0}
        numberOfPieces={20}
        recycle={false}
        tweenDuration={700}
        gravity={0.3} // gravity 값 추가 (기본값 0.1)
        initialVelocityY={12} // 초기 수직 속도 감소
        colors={['#F8623F', '#FFB266', '#FF80A9', '#6ECFBC', '#8EA1FF', '#3843D0', '#8E59FF']}
        confettiSource={{
          x: window?.innerWidth ? window.innerWidth / 2 : 0, // 화면 가로 중앙
          y: window?.innerHeight ? window.innerHeight / 2 - 20 : 0, // 820px 기준 90px의 비율로 계산
          w: 0,
          h: 0,
        }}
      />

      <ModalContainer>
        <ModalHeader>
          <ModalIcon src={'/images/icon/ico_success.svg'} alt="alert icon" width={56} height={56} />
        </ModalHeader>
        <ModalBody>
          <ModalTitleWrapper>
            <ModalTitle>{point}P를 받았어요!</ModalTitle>
          </ModalTitleWrapper>
        </ModalBody>
        <ModalFooter>
          <ModalFooterButtonWrapper>
            <Button colorType="purple" onClick={handleOnClose}>
              12시간 뒤에 또 만나요!
            </Button>
          </ModalFooterButtonWrapper>
        </ModalFooter>
      </ModalContainer>
    </Container>
  );
};

export default DailyAttendanceModal;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100dvw;
  height: 100dvh;
`;

const ModalContainer = styled(ModalContent)`
  border-radius: var(--radius-Small, 8px);
  overflow: hidden;
`;
